import { StoryVideo } from '../../types/StoryVideo';
import createInfiniteScrollStore from '../infiniteScrollStore';

export const useVideosStore = createInfiniteScrollStore<StoryVideo>();
